import { render } from "./Results.vue?vue&type=template&id=19f84410"
import script from "./Results.vue?vue&type=script&lang=js"
export * from "./Results.vue?vue&type=script&lang=js"

import "./Results.vue?vue&type=style&index=0&id=19f84410&lang=css"
script.render = render

export default script